// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-question .date-time-pickers {
    display: flex;
    justify-content: left;
    gap: 10px;
    flex-wrap: wrap;
    row-gap: 0;
}

.date-question .date-time-pickers .date-picker {
    width: 155px;
}

.date-question .date-time-pickers .time-picker {
    width: 135px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Questions/DateQuestion/DateQuestion.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".date-question .date-time-pickers {\n    display: flex;\n    justify-content: left;\n    gap: 10px;\n    flex-wrap: wrap;\n    row-gap: 0;\n}\n\n.date-question .date-time-pickers .date-picker {\n    width: 155px;\n}\n\n.date-question .date-time-pickers .time-picker {\n    width: 135px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
